'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

export type CustomerContextValue = {
    isCustomer: boolean | undefined;
};

const DEFAULT_CONTEXT_VALUE: CustomerContextValue = {
    isCustomer: undefined,
};

const CustomerContext = createContext<CustomerContextValue>(DEFAULT_CONTEXT_VALUE);

export const useCustomerContext = (): CustomerContextValue =>
    useContext(CustomerContext) || DEFAULT_CONTEXT_VALUE;

export function CustomerContextProvider({
    children,
    value,
}: PropsWithChildren<{ value: CustomerContextValue }>) {
    return <CustomerContext.Provider value={value}>{children}</CustomerContext.Provider>;
}
